import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsCouponNotFound extends AnnualPeriodsError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('Promotional coupon id not found', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualPeriodsCouponNotFound;
